<template>
  <el-select v-model="selectedDictId" size="small" clearable filterable v-bind="$attrs" v-on="$listeners" @change="onDictChanged">
    <el-option v-for="item in dictList" :key="item.dicId" :label="item.cnName" :value="item.dicId" />
  </el-select>
</template>
<script>
import dicService from '@/CommonDP/service/dic-service';

export default {
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    dictCode: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      selectedDictId: "",
      dictList: []
    };
  },

  watch: {
    value(newVal) {
      if (newVal !== this.selectedDictId) {
        this.selectedDictId = newVal;
      }
    },
    selectedDictId(newVal) {
      this.$emit("input", newVal);
    },
    dictCode() {
      this.$nextTick();
      this.queryDictList();
    }
  },

  mounted() {
    this.queryDictList();
  },

  methods: {
    async queryDictList() {
      console.debug("dicCode............", this.dictCode);
      if (!this.dictCode) {
        return;
      }
      const res = await dicService.getDicList(this.dictCode);
      this.dictList = res.data || [];
    },

    async onDictChanged() {
      this.$nextTick();
      const selected = this.dictList.find(item => item.dicId === this.selectedDictId);
      this.$emit("dictChanged", selected);
    }
  }
};
</script>
